
<template>
  <section class="content data">
    <h4>参会信息</h4>
    <el-divider></el-divider>
    <el-form label-width="80px" class="filter-form">
      <el-row>
        <el-col :span="5">
          <el-form-item label="名字">
            <el-input
              clearable
              @clear="getData()"
              v-model="queryParams.name"
              placeholder="请输入名字"
              size="mini"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="手机号">
            <el-input
              clearable
              @clear="getData()"
              v-model="queryParams.phone"
              placeholder="请输入手机号"
              size="mini"
            ></el-input>
          </el-form-item>
        </el-col>
        
        <el-col :span="4">
          <el-form-item style="margin-left:10px;" label-width="10">
            <el-button type="primary" @click="getData" size="mini">筛选</el-button>
            <el-button type="normal" @click="queryParams={},getData()" size="mini">重置</el-button>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6"></el-col>
      </el-row>
    </el-form>
    <el-table :data="list" height="55vh" style="width: 100%;margin-top:10px;" v-loading="loading">
      <el-table-column prop="product.name" label="门票类型" />
      <el-table-column prop="product.price" label="费用" />
      <el-table-column prop="name" label="名字" />
      <el-table-column prop="phone" label="手机号" />
      <el-table-column prop="address" label="省/市" />
      
    </el-table>
    <Page
            ref="pageButton"
            :current="form.page"
            :page_size="form.page_size"
            :total="total"
            @pageChange="gopage"
        />
  </section>
</template>
<script>
import Page from "../../components/Page";
export default {
    components: {
    Page
  },
  data() {
    return {
      loading: false,
      queryParams: {
        page: 1,
      },
      list:[],
      form:{},
      total:0,
    };
  },
  methods: {
    gopage(size) {
      if (size) {
        this.queryParams.page_size = size;
      }
      this.queryParams.page = this.$refs.pageButton.page;
      this.getData();
    },
    getData() {
      this.loading = true;
      this.$api.getProductList(this.queryParams).then(res => {
        console.log('product',res.data.data)
        this.list = res.data.data.list;
        this.total = res.data.data.total;
        this.loading = false;
      });
    }
  },
  created() {
    this.getData();
  }
};
</script>